import { cn } from "@/lib/utils";

const MAP = {
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  late: { label: "Late", cls: "bg-amber-50 text-amber-900 border-amber-400" },
  paid_off: { label: "Paid Off", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  partial: { label: "Partial", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  upcoming: { label: "Upcoming", cls: "bg-transparent text-muted-foreground border-border" },
  posted: { label: "Posted", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  voided: { label: "Voided", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  submitted: { label: "Submitted", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  under_review: { label: "Under Review", cls: "bg-amber-50 text-amber-900 border-amber-400" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  outstanding: { label: "Outstanding", cls: "bg-amber-50 text-amber-900 border-amber-400" },
  waived: { label: "Waived", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  unsent: { label: "Unsent", cls: "bg-transparent text-muted-foreground border-border" },
  sent: { label: "Sent", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  failed: { label: "Failed", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  Sent: { label: "Sent", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  Failed: { label: "Failed", cls: "bg-rose-50 text-rose-700 border-rose-300" },
};

export const StatusBadge = ({ status, testid }) => {
  const s = MAP[status] || { label: status, cls: "" };
  return (
    <span
      data-testid={testid}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap", s.cls)}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {s.label}
    </span>
  );
};
